import CampaignsList from "./campaigns/List";
import CreateCampaign from "./campaigns/Create";
import UpdateCampaign from "./campaigns/Update";
import DuplicateCampaign from "./campaigns/Duplicate";

export const Campaigns = {
  list: CampaignsList,
  update: UpdateCampaign,
  duplicate: DuplicateCampaign,
  create: CreateCampaign,
};

// export { default as UnexpectedErrorScreen } from './UnexpectedErrorScreen_deprecated';
export { default as ErrorScreen } from "./ErrorScreen";
export { default as NotFoundScreen } from "./NotFoundScreen";
export { default as LoginScreen } from "./LoginScreen";
export { default as LogoutScreen } from "./LogoutScreen";
// export { default as CallbackScreen } from './__CallbackScreenen';
export { default as CartScreen } from "./CartScreen";
export { default as CodCheckout } from "./CodCheckout";
export { default as DashboardScreen } from "./DashboardScreen";
export { default as FaqScreen } from "./FaqScreen";
export { default as PrivacyPolicy } from "./PrivacyPolicy";
export { default as ManualSetup } from "./ManualSetup";
export { default as PlanScreen } from "./PlanScreen";
export { default as StickyCartSettings } from "./StickyCartSettings";
export { default as InvitationScreen } from "./InvitationScreen";
export { default as Affiliation } from "./Affiliation";
export { default as ReferralScreen } from "./ReferralScreen";
export { default as NewLoginScreen } from "./NewLoginScreen";
export { default as Integrations } from "./Integrations";
export { default as SwitchingVersionScreen } from "./SwitchingVersionScreen";
